import IPCIDR from 'ip-cidr'
import { APP_ENV } from '~/constants/env'

export default defineNuxtRouteMiddleware(() => {
  const config = useRuntimeConfig()
  const headers = useRequestHeaders()

  // Exit early if not in production environment
  if (config.public.APP_ENV !== APP_ENV.PROD) {
    return
  }

  const ua = headers?.['user-agent']?.toLowerCase() || ''
  if (checkIsBotAgent(ua)) { return }

  const incomingCountryCode = headers?.['cf-ipcountry']
  const incomingIp = headers?.['cf-connecting-ip']
  const rawCIDR = config.CIDR_WHITELIST
  const rawBlockCountryCodeConfig = config.BLOCK_COUNTRY_CODE

  // Exit early if required headers or configs are missing
  if (!incomingCountryCode || !rawCIDR || !incomingIp || !rawBlockCountryCodeConfig) { return }

  // Process whitelist CIDR
  const wlCIDRList = rawCIDR.split(',').map((cidr) => cidr.trim())
  const wlCIDRInstanceList = wlCIDRList.map((cidr) => new IPCIDR(cidr))
  const isWhiteListIp = wlCIDRInstanceList.some((cidrInstance) => cidrInstance.contains(incomingIp))

  // Bypass if the IP is in the whitelist
  if (isWhiteListIp) { return }

  // Process blocked country codes
  const blockedCountryCodeList = rawBlockCountryCodeConfig.split(',').map((c) => c.trim())
  if (blockedCountryCodeList.includes(incomingCountryCode)) {
    return createError({
      statusCode: 403,
      data: {
        incomingIp,
        incomingCountryCode
      }
    })
  }
})

// Helper function to check if the user agent belongs to a bot
const checkIsBotAgent = (userAgent: string) => userAgent?.includes('bot')
